import React, {useEffect, useState} from "react";
import "./Product_Clothing.scss";
import {Header_Clothing} from "../Component_Clothing/Header_Clothing/Header_Clothing";
import {clothing_product} from "../Services_Clothing";
import {useParams} from "react-router";
import {useBasket, useDispatchBasket} from "../../../hooks";
import {AddBasket, RemoveBasket} from "../../../Components/OnlineAddress/OnlineAddressService";
import {OnlineStoreHomeData} from "../../StyleShop/OnlineStyleShopServices";

function AddToBasket({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();


    //states
    const [loading,set_loading] = useState(false)

    useEffect(()=>{
    },[])

    const addToBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId,pId,item)
        // console.log("Add : ",response)
    }

    const removeFromBasket = async (pId) =>{
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId,pId)
        // console.log("Remove : ",response)
    }

    //functions
    const inc = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if(basket.find(product=>product.product.uid===item.uid)){
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count+1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket",JSON.stringify(filter));
        }else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product:item,count:1}]);
            //storage change
            localStorage.setItem("basket",JSON.stringify([...basket, {product:item,count:1}]));
        }

    }

    const dec = async () =>{
        if(loading){return }
        try{
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        }catch (e) {
            set_loading(false)
            return ;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product=>product.product.uid===item.uid);
        if(find){
            //exist
            if(find.count>0){
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count : pro.count-1} : pro)

                if(find.count===1){
                    //context change
                    setBasket(basket.filter(product=>product.product.uid!==item.uid))
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
                }else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket",JSON.stringify(filter));
                }
            }else {
                //context change
                setBasket(basket.filter(product=>product.product.uid!==item.uid))
                //storage change
                localStorage.setItem("basket",JSON.stringify(basket.filter(product=>product.product.uid!==item.uid)));
            }
        }
    }

    const remove = () =>{
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product=>product.product.uid!==item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(()=>{
            localStorage.setItem("basket",JSON.stringify(basket));
        },500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product=>product.product.uid===item.uid);
        if(basket_count){
            return basket_count.count;
        }
        return 0;
    }


    return(
        <div className="add-remove-section-footer" style={{
            backgroundColor: '#e0e0e0',
            margin: '4px 24px',
            borderRadius: 5,
            padding: '4px 13px',
            fontFamily:'YekanRegular'
        }}>
            {checkCount()<1?<span className="add-btn-text" style={{width:'100%'}}  onClick={inc}>

                <div className="buy-btn" style={{margin:0}}>
                <div className="price">
                    <span> { numberWithCommas(item.price)} ریال </span>
                </div>
                <div className="title">
                    <span>اضافه کردن به سبد خرید</span>
                </div>
            </div>
                </span>:
                <div className="active-footer-sec">
                    <div className="price-footer-sec">
                        <div className="percent-off-footer-cont">
                            {item && item.discount_percentage!==0?
                                <span className="percent-off-footer"
                                style={{width:25,height:25,fontSize:12}}
                                >%{item.discount_percentage}</span>:
                                null
                            }

                            <span style={{textDecoration:"line-through",fontSize:14}}>{numberWithCommas(checkCount()*item.price_original)}</span>
                        </div>
                        <div style={{direction:"rtl"}}><span>{numberWithCommas(checkCount()*item.price)} ریال </span></div>
                    </div>
                    <div className="calc">
                        {/*{item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:null}*/}
                        {checkCount()>0?<>
                            <i className="fa fa-minus" onClick={dec}></i>
                            <span style={{direction:"rtl",padding:"0 16px",
                                color: 'black',
                                backgroundColor: 'transparent',
                                border: 'none'
                            }} className="product-count-number">
                            {!loading?checkCount():<i className="fa fa-spinner fa-spin"></i>}
                        </span>
                        </>:null}
                        <i className="fa fa-plus" onClick={inc}></i>
                    </div>
                </div>
            }
        </div>
    )
}


function numberWithCommas  (x) {
    if (x === 0) {
        return 0
    }
    if(x){
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function Product_Clothing() {

    //hooks
    const {merchantId,productId} = useParams()


    useEffect(()=>{
        window.scrollTo({left: 0, top: 0});
        getProduct()
    },[])



    const [product,set_product] = useState({})


    const [color,set_color] = useState('#DE7B50')
    const [size,set_size] = useState('S')


    const getProduct = async () =>{
        const response = await clothing_product(merchantId,productId);
        console.log(response.data)
        response.data['sizes'] =['S','L','XL'];
        response.data['colors'] =['#C4C4C4','#B88942','#DE7B50','#E06B6B'];
        response.data['desc'] ="دم رازاب هب یراج لاس رد هک نوتیو ییول هزییاپ لدم نیزت هزات\n" +
            "یلصا گنر رهچ رد هدش وربور یدایز لابقتسا اب و هدش هضرع";


        set_product(response.data)

    }


    return(
        <div className="product-clothing-container">
            <Header_Clothing/>
            <div className="image-container" style={{backgroundImage: `url(${product.image})`}}>
                <div className="info-sec">
                    <div className="info-sec-name">
                        {product.name}
                    </div>
                    <div className="info-sec-desc">
                        {product.desc}
                    </div>
                </div>
            </div>

            <div className="product-color">
                <div className="title">
                    <span>رنگ</span>
                </div>
                <div className="pallet">
                    {product&& product.colors&& product.colors.map(item=>{
                        return(
                            <div className="pallet-item" onClick={()=>{
                                set_color(item)
                            }} style={{backgroundColor:item}}>
                                {color===item?
                                    <div className="pallet-active">
                                    </div>:null
                                }
                            </div>
                        )
                    })}
                </div>
            </div>


            <div className="product-size">
                <div className="title">
                    <span>اندازه</span>
                </div>
                <div className="sizes">
                    {product && product.sizes && product.sizes.map(item=>{
                        return(
                            <div
                                onClick={()=>{
                                    set_size(item)
                                }}
                                className={size===item?"size-item-active":"size-item"}>{item}</div>
                        )
                    })}
                </div>
            </div>


            {/*<div className="product-count">*/}
            {/*    <div className="title">*/}
            {/*        <span>تعداد</span>*/}
            {/*    </div>*/}
            {/*    <div className="count">*/}
            {/*        <select name="" id="">*/}
            {/*            <option value="0">0</option>*/}
            {/*            <option value="0">1</option>*/}
            {/*            <option value="0">2</option>*/}
            {/*            <option value="0">3</option>*/}
            {/*            <option value="0">4</option>*/}
            {/*            <option value="0">5</option>*/}
            {/*        </select>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="buy-btn-wr">
                <AddToBasket item={product}/>
            </div>

        </div>
    )

}
export {Product_Clothing}
